// components/Admin/SimpleInvoice.js
import React, { useState } from 'react';
import { Page, Text, View, Document, StyleSheet, PDFDownloadLink } from '@react-pdf/renderer';

const styles = StyleSheet.create({
  page: {
    padding: 30,
  },
  line: {
    fontSize: 10,
    marginBottom: 2,
  }
});

// Generate a simple document with many lines
const SimpleInvoicePDF = ({ itemCount }) => {
  const items = [];
  for (let i = 1; i <= itemCount; i++) {
    items.push(
      <Text key={i} style={styles.line}>
        Item {i}: This is a test item description with some text to make it longer
      </Text>
    );
  }
  
  return (
    <Document>
      <Page size="A4" style={styles.page}>
        <Text style={{ fontSize: 20, marginBottom: 20 }}>SIMPLE INVOICE</Text>
        <Text style={{ fontSize: 12, marginBottom: 10 }}>Date: {new Date().toLocaleDateString()}</Text>
        <Text style={{ fontSize: 12, marginBottom: 20 }}>Invoice #: TEST-001</Text>
        
        {items}
        
        <Text style={{ fontSize: 12, marginTop: 20 }}>Total: $1,000.00</Text>
      </Page>
    </Document>
  );
};

const SimpleInvoice = () => {
  const [itemCount, setItemCount] = useState(5);
  
  return (
    <div style={{ padding: '20px' }}>
      <h1>Simple Invoice Test</h1>
      <div>
        <label>Number of items: </label>
        <input 
          type="number" 
          value={itemCount} 
          onChange={(e) => setItemCount(parseInt(e.target.value) || 1)}
          min="1"
          max="200"
        />
      </div>
      <div style={{ marginTop: '20px' }}>
        <PDFDownloadLink 
          document={<SimpleInvoicePDF itemCount={itemCount} />} 
          fileName={`simple_invoice_${itemCount}_items.pdf`}
        >
          {({ loading }) => (
            <button style={{ padding: '10px 20px', fontSize: '16px' }}>
              {loading ? 'Generating...' : `Download PDF with ${itemCount} items`}
            </button>
          )}
        </PDFDownloadLink>
      </div>
    </div>
  );
};

export default SimpleInvoice;